import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_ADD_PROJECT_SITEMAP_XML_BEGIN,
  APP_SETTING_ADD_PROJECT_SITEMAP_XML_SUCCESS,
  APP_SETTING_ADD_PROJECT_SITEMAP_XML_FAILURE,
  APP_SETTING_ADD_PROJECT_SITEMAP_XML_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import axios from 'axios';

export function addProjectSitemapXml(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_PROJECT_SITEMAP_XML_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/sitemapXml`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_SITEMAP_XML_SUCCESS,
              data: res.data,
            });
            toast.success('Saved Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_SITEMAP_XML_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_PROJECT_SITEMAP_XML_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddProjectSitemapXmlError() {
  return {
    type: APP_SETTING_ADD_PROJECT_SITEMAP_XML_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_PROJECT_SITEMAP_XML_BEGIN:
      return {
        ...state,
        addProjectSitemapXmlPending: true,
        addProjectSitemapXmlError: null,
      };

    case APP_SETTING_ADD_PROJECT_SITEMAP_XML_SUCCESS:
      return {
        ...state,
        addProjectSitemapXmlPending: false,
        addProjectSitemapXmlError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_PROJECT_SITEMAP_XML_FAILURE:
      return {
        ...state,
        addProjectSitemapXmlPending: false,
        addProjectSitemapXmlError: action.data.error,
      };

    case APP_SETTING_ADD_PROJECT_SITEMAP_XML_DISMISS_ERROR:
      return {
        ...state,
        addProjectSitemapXmlError: null,
      };

    default:
      return state;
  }
}
